import { CommandBody } from "../common/types/apiTypes";
import { EventPayload } from "../common/types/Event";
import { Options } from "../common/types/requestOptions";
import { api } from "./api";

export const command = async <
  TBody extends CommandBody, // command body type
  TEvent, // event type
>(
  endpoint: string,
  body: TBody,
  { requestId }: Options = {},
): Promise<EventPayload<TEvent>[]> => {
  return api
    .post<EventPayload<TEvent>[]>(endpoint, {
      requestId,
      auth: true,
      body,
    })
    .then((res) => res.data);
};
